import { parsePhoneNumber } from 'libphonenumber-js';

import { countryOptions, CountryPhoneInfo } from './country-data';
import { countryCodesByTimezone } from './timezone-country-data';

export const cleanPhoneNumber = (phone: string) => {
  if (!phone) return '';

  const hasPlus = phone.startsWith('+');
  const cleaned = phone.replace(/\D/g, '');
  return hasPlus ? `+${cleaned}` : cleaned;
};

export const serializePhoneNumber = (phone: string) => (phone ? `+${cleanPhoneNumber(phone)}` : '');

export const parsePhoneAndFindCountry = (phone: string, currentCountry?: CountryPhoneInfo) => {
  try {
    const parsed = parsePhoneNumber(`+${currentCountry?.code}${phone}`);
    if (parsed.country && parsed.country !== currentCountry?.country) {
      return countryOptions.find((c) => c.country === parsed.country) || currentCountry;
    }
  } catch (ParseError) {}

  return currentCountry;
};

export const parseCountryMask = (country: CountryPhoneInfo) => {
  return country.mask.split('').map((l) => (l === '.' ? /\d/ : l));
};

export const parsePhone = (phone?: string, isCountryPrefilled: boolean = false) => {
  let selectedCountry: CountryPhoneInfo | undefined;

  if (isCountryPrefilled) {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const country = countryCodesByTimezone[timezone];
    selectedCountry = countryOptions.find((c) => c.country === country);
  }

  if (!phone) {
    return { selectedCountry, phone: '' };
  }

  phone = cleanPhoneNumber(phone);

  try {
    // Try parsing the default value
    // If it doesnt start with a +, treat it like a +354 number to handle old values
    const parsed = parsePhoneNumber(phone, 'IS');

    if (parsed.country) {
      selectedCountry = countryOptions.find((c) => c.country === parsed.country);
      if (selectedCountry) {
        phone = parsed.number.replace(`+${selectedCountry.code}`, '');
      }
    }
  } catch (ParseError) {}

  return {
    selectedCountry,
    phone,
  };
};
